import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const DestinationLinkSC = styled(Link)`
  position: relative;
  display: inline-flex;

  width: 200px;
  min-height: 56px;
  padding-left: 16px;
  padding-right: 16px;
  transition: all 0.2s;

  text-decoration: none !important;

  &:not(.active) {
    .content {
      opacity: 0.6;
    }
  }

  .content {
    margin: 16px 0;
    color: ${({ theme }) => theme.color.tint.primaryDark};
    ${({ theme }) => theme.mappedTypography.h6.default};
    transition: all 0.2s;
  }

  .icon-wrapper {
    position: relative;
    width: 40px;
    height: 40px;
    margin-top: 8px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:hover:not(:disabled) {
    cursor: pointer;
    background-color: ${({ theme }) =>
      theme.createOverlayColor(theme.color.surface.backgroundDark, 'hover', 'dark')};
  }

  &.active {
    background-color: ${({ theme }) =>
      theme.createOverlayColor(theme.color.surface.backgroundDark, 'focused', 'dark')};
  }

  .sidebar-collapsed & {
    .content {
      opacity: 0;
    }
  }
`;
